import { capitalizeAllWords } from './capitalizeAllWords';

interface FormatAddressProps {
  street?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  suiteNumber?: string | null;
}

interface FormatAddressOptions {
  isAllUpperCase?: boolean;
}

export const formatAddress = (
  { street, city, state, postalCode, country, suiteNumber }: FormatAddressProps = {},
  { isAllUpperCase }: FormatAddressOptions = {},
) => {
  const addressComponents = [];

  const formattedStreet = capitalizeAllWords(street || '');
  const formattedCity = capitalizeAllWords(city || '');
  const formattedState = state ? state.toUpperCase().substring(0, 2) : '';
  const validatePostalCode = postalCode ?? '';
  const formattedPostalCode = validatePostalCode.includes('-')
    ? validatePostalCode.substring(0, 5)
    : validatePostalCode;
  const formattedCountry = country ? country.toUpperCase() : '';

  if (street) {
    addressComponents.push(formattedStreet);
  }

  if (suiteNumber) {
    addressComponents.push(suiteNumber);
  }

  if (city) {
    addressComponents.push(formattedCity);
  }

  if (state) {
    addressComponents.push(formattedState);
  }

  if (postalCode) {
    addressComponents.push(formattedPostalCode);
  }

  if (country) {
    addressComponents.push(formattedCountry);
  }

  let address = capitalizeAllWords(addressComponents.join(', '));

  if (isAllUpperCase) {
    return address.toUpperCase();
  }

  /**
   * cleaning section of commas
   */
  if (street && suiteNumber) {
    address = address.replace(`${formattedStreet},`, `${formattedStreet}`);
  }

  if (state && postalCode) {
    address = address.replace(`${formattedState},`, `${formattedState}`);
  }

  if (postalCode && country) {
    address = address.replace(`${postalCode},`, `${postalCode}`);
  }

  if (street && city && state && country) {
    address = address.replace(
      `${formattedStreet}, ${formattedCity}, ${formattedState}, ${formattedCountry}`,
      `${formattedStreet}, ${formattedCity}, ${formattedState} ${formattedCountry}`,
    );
  }

  return address;
};
